// removed by extract-text-webpack-plugin
module.exports = {"tab-link":"tab-link__2WH8Y","vertical":"vertical__14R5t","nested-ul":"nested-ul__Bn02u","nested-li":"nested-li__1XoBG","active":"active__Eb_MI","sub-links":"sub-links__EfTmg","horizontal":"horizontal__1U94G","tab-link-icons":"tab-link-icons__lYMql","tab-link-label":"tab-link-label__4xNaX","disabled":"disabled__3jxEd","secondary-tab":"secondary-tab__1mtPj","filled":"filled__7YZd-","mobile-filter-tabs":"mobile-filter-tabs__1USf5","newClass":"newClass__2aoRE"};


//////////////////
// WEBPACK FOOTER
// ./styles/tabs.scss
// module id = 1073
// module chunks = 68